import { Type } from "class-transformer";

export class Transaction {
    id!: string;
    message!: string;
}

export class TransactionsResponse {
    name!: string;
    @Type(() => Transaction)
    actions!: Transaction[]
    path!: string;
}

export class TransactionOtpResponse {
    phone?: string;
    email?: string;

    getAddresses(separator = '/') {
        var medium: string[] = []
        if (this.phone) {
            medium.push(this.phone)
        }
        if (this.email) {
            medium.push(this.email)
        }

        return medium.join(separator)
    }
}